import { useMemo, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSwimmersPreviewResource } from "../../../swimmers/hooks/useSwimmersPreviewResource";
import { useGetBuildings } from "../../../buildings/services/buildingService";
import type { SwimmerReportDataItem } from "../../../../api/client/types/swimmer.types";
import { ROUTES } from "../../../../routes/routes";
import { useSaveScrollOnReturn } from "../../../../shared/hooks/useSaveScrollOnReturn";
import { SWIMMERS_PREVIEW_SCROLL_KEY } from "../../../../shared/utils/sessionStorageKeys";

export const useSwimmersPreviewTab = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const swimmersResource = useSwimmersPreviewResource();
  const { data: buildings } = useGetBuildings({ page_size: 1000 });
  const saveScrollBeforeNavigate = useSaveScrollOnReturn(
    SWIMMERS_PREVIEW_SCROLL_KEY
  );

  // Building options for select dropdown
  const buildingOptions = useMemo(() => {
    const options = [{ value: "", label: "Todas las unidades" }];
    if (buildings?.items) {
      buildings.items.forEach((building) => {
        options.push({
          value: building.id,
          label: building.name,
        });
      });
    }
    return options;
  }, [buildings]);

  return {
    swimmersResource,
    buildingOptions,
    handleEditSwimmer: useCallback(
      (item: SwimmerReportDataItem) => {
        saveScrollBeforeNavigate(() =>
          navigate(ROUTES.SWIMMERS.EDIT(item.swimmer_id), {
            state: { returnSearch: location.search || "?tab=banistas" },
          })
        );
      },
      [navigate, location.search, saveScrollBeforeNavigate]
    ),
    handleDeleteSwimmer: useCallback(
      (swimmerId: string) => {
        saveScrollBeforeNavigate(() =>
          navigate(ROUTES.SWIMMERS.DELETE(swimmerId), {
            state: { returnSearch: location.search || "?tab=banistas" },
          })
        );
      },
      [navigate, location.search, saveScrollBeforeNavigate]
    ),
  };
};
